module.exports = __webpack_public_path__ + "img/06.d6c6fd83.png";